import { jsx as e } from "react/jsx-runtime";
import a from "./Tooltip.js";
import C from "../overlay/OverlayTrigger.js";
import { PLACEMENT as E } from "../../values/Placement.js";
import { TRIGGER as r } from "../../values/Trigger.js";
const o = (t) => {
  const {
    children: i,
    placement: p = E.AUTO,
    trigger: m,
    content: n,
    delay: R,
    popperConfig: l,
    targetRef: f,
    ...T
  } = t;
  return /* @__PURE__ */ e(
    C,
    {
      placement: p,
      trigger: m,
      overlay: /* @__PURE__ */ e(a, { ...T, ref: f, children: n }),
      delay: R,
      popperConfig: l,
      children: i
    }
  );
};
o.TRIGGER_CLICK = r.CLICK;
o.TRIGGER_HOVER = r.HOVER;
o.TRIGGER_FOCUS = r.FOCUS;
export {
  o as default
};
//# sourceMappingURL=SimpleTooltip.js.map
